









































import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class DeleteBrandTutorialVideoPopup extends Vue {
  @Prop() popupId!: string
  @Prop() brandTutorialVideoDetails!: any

  deleteBrandTutorialVideo () {
    this.$http
      .delete(process.env.VUE_APP_API_BASE_URL + '/brand_video_tutorials/' + this.brandTutorialVideoDetails.id, {
        headers: {
          'user-type': 'sadmin'
        }
      })
      .then((response) => {
        this.$emit('updateBrandTutorialVideosList')
        let DeleteLocationCloseButtonPopup: HTMLElement = this.$refs.detelBrandTutorialVideoPopupCloseButton as HTMLElement
        DeleteLocationCloseButtonPopup.click()
      })
  }
}
